import SiteHeader from '@/pages/home/components/SiteHeader';
import HeroSpread from '@/pages/home/components/HeroSpread';
import FlashTimeline from '@/pages/home/components/FlashTimeline';
import CollectionIndex from '@/pages/home/components/CollectionIndex';
import TopicBoard from '@/pages/home/components/TopicBoard';
import CommunityZone from '@/pages/home/components/CommunityZone';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-background-50 font-body text-foreground-950">
      <SiteHeader />
      <main>
        <HeroSpread />
        <FlashTimeline />
        <CollectionIndex />
        <TopicBoard />
        <CommunityZone />
      </main>
      <SiteFooter />
    </div>
  );
}